<template>
  <v-card :loading="loading" :disabled="loading">
    <v-toolbar flat>
      <v-icon left color="accent">mdi-golf-cart</v-icon>
      <v-toolbar-title>Woods</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        @click="openForm()"
        :disabled="!isModifiable"
      >
        <v-icon>mdi-plus</v-icon>Add Wood
      </v-btn>
    </v-toolbar>

    <PrescriptionItems
      :headers="woodHeaders"
      :items="items"
      :isModifiable="isModifiable"
      @update="update()"
      @edit="(item) => openForm(item)"
    />

    <wood-form
      ref="woodForm"
      :prescriptionId="prescriptionId"
      :dominantHand="this.dominantHand"
      :currency="prescription.currency.currency"
      :catalogId="this.catalogId"
      @update="update()"
    ></wood-form>
  </v-card>
</template>

<script>
import PrescriptionItems from './PrescriptionItems.vue';
import WoodForm from "./WoodForm";

export default {
  components: {
    WoodForm,
    PrescriptionItems
},
  props: ["woods", "prescriptionId", "dominantHand", "shopId", 'catalogId', "prescription"],
  data: function() {
    return {
      items: this.woods,
      woodToEdit: null,
      formEdit: false,
      formType: "solo",
      woodHeaders: [
        { text: "Quote", value: "quote", sortable: false },
        { text: "Quantity", value: "quantity" },
        { text: "SST Pure", value: "sst", sortable: false },
        { text: "Head", value: "head" },
        { text: "Shaft", value: "shaft" },
        { text: "Grip", value: "grip" },
        { text: "Actions", value: "actions"},
      ],
      loading: false
    };
  },
  computed : {
    isModifiable () {
      return this.prescription.isModifiable
    }
  },
  methods: {
    getWoods() {
      this.loading = true
      this.$store
        .dispatch("prescriptionWood/get", {
          id: this.prescriptionId
        })
        .then(datas => (this.items = datas))
        .finally(() => {this.loading = false});
    },
    update() {
      this.getWoods()
      this.$emit("update")
    },
    openForm(item) {
      this.$refs.woodForm.open(item)
    }
  }
};
</script>

<style></style>
